import { render } from "./ImageUploader.vue?vue&type=template&id=6ecef71c&scoped=true"
import script from "./ImageUploader.vue?vue&type=script&lang=ts"
export * from "./ImageUploader.vue?vue&type=script&lang=ts"

import "./ImageUploader.vue?vue&type=style&index=0&id=6ecef71c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6ecef71c"

export default script